export default __webpack_public_path__ + "static/media/HotelTravelLandingPage.7cba2215.jpeg";